import { get, post } from '@utils/request';

const preview = 'coupon/';

export const getCouponslList = (params) => get(`${preview}userCouponList`, params);

// ldy 优惠券前置
export const getCouponsDetail = (params) => get('couponPrepose/couponDetail', params);
export const getUserCouponsDetail = (params) => get('couponPrepose/isReceiveCoupon', params);
export const getCoupons = (params) => get('couponPrepose/receiveCoupon', params);

export const seletcActivity = params => get(`${preview}seletcActivity`, params);

// 购物车-获取优惠券列表
export const getScCouponslList = (data) => post(`${preview}userScCouponList`, data);

// @aigc:start 2024/03/04-16:01
// 单报商品获取优惠券数据
export const getSingleGoodsCoupons = (params) => get(`${preview}userCouponList/v2`, params);
// @aigc:end 2024/03/04-16:01

// 根据id查询优惠券信息
export const getCouponInfoById = (params) => get(`${preview}getListByCouponCodes`, params);
